module.exports = __webpack_public_path__ + "static/VH_Pixel_Logo_black-df9c31ac0e5cb5330fe70fe3aa8045b8.png";